<template>
  <div id="app">
    <div>
    <label for="example-datepicker">Fetch Data Starting From: </label>
    <input type="date" v-model="startTime">
    <p>Selected Time: '{{ startTime }}'</p>
    <b-button class="rounded-pill m-4" variant="info" @click="fetchTrialData">
        Fetch Trial Data
    </b-button>
    <b-button class="rounded-pill m-4" variant="info" @click="fetchDemoData">
        Fetch Demographic Data
    </b-button>
    <!-- <b-button class="rounded-pill m-4" variant="info" @click="fetchEplData">
        Fetch Explaination Data
    </b-button> -->
    </div>
    <div v-if="ShowDownload">
      Here is data starting from {{ startTime }}.
    <b-button class="rounded-pill m-4" variant="info">
      <download-excel
      class="export-excel-wrapper"
      :data="task_data"
      type="xls"
      :name="filename">
    </download-excel>
      </b-button>
    <div class='mx-4'>
      <b-table striped hover :items="task_data"></b-table>
    </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      task_data: [],
      json_meta: [
        [{
          ' key ': ' charset ',
          ' value ': ' utf- 8 ',
        }],
      ],
      filename: null,
      ShowDownload: false,
      startTime: null,
      todayDate: null,
    };
  },
  methods: {
    fetchTrialData() {
      const payload = {
        time: this.startTime,
      };
      const path = `${this.$hostname}/get-download-data`;
      axios
        .post(path, payload)
        .then((res) => {
          console.log(res.data.Auth);
          if (res.data.Auth !== 'admin') {
            this.$router.push({ name: 'Task' });
          } else {
            this.task_data = res.data.task_data;
            this.filename = `${this.todayDate}_trial-data.xls`;
            this.ShowDownload = true;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchDemoData() {
      const payload = {
        time: this.startTime,
      };
      const path = `${this.$hostname}/get-download-demographic`;
      axios
        .post(path, payload)
        .then((res) => {
          console.log(res.data.Auth);
          if (res.data.Auth !== 'admin') {
            this.$router.push({ name: 'Task' });
          } else {
            this.task_data = res.data.task_data;
            this.filename = `${this.todayDate}_demographic-data.xls`;
            this.ShowDownload = true;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchEplData() {
      const payload = {
        time: this.startTime,
      };
      const path = `${this.$hostname}/get-download-explaination`;
      axios
        .post(path, payload)
        .then((res) => {
          console.log(res.data.Auth);
          if (res.data.Auth !== 'admin') {
            this.$router.push({ name: 'Task' });
          } else {
            this.task_data = res.data.task_data;
            this.filename = `${this.todayDate}_explaination-data.xls`;
            this.ShowDownload = true;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getToday() {
      const today = new Date();
      const dd = today.getDate();
      const mm = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      this.todayDate = `${yyyy}-${mm}-${dd}`;
    },
  },
  created() {
    this.getToday();
  },
};
</script>
